import { createColorKeys } from '~/utils/chakraUtils'

import { accountButtonColors } from './AccountButton.colors'
import { doNotDisturbSplitButtonColors } from './DoNotDisturbSplitButton.colors'
import { environmentLabelColors } from './EnvironmentLabel.colors'
import { queueControlButtonColors } from './QueueControlButton.colors'
import { topNavColors as topNavBannerColors } from './TopNav.colors'

// This is referenced in src/themes/colors/colors.ts
export const topNavColors = {
  TopNav: {
    ...topNavBannerColors,
    EnvironmentLabel: { ...environmentLabelColors },
    DoNotDisturbSplitButton: { ...doNotDisturbSplitButtonColors },
    AccountButton: { ...accountButtonColors },
    QueueControlButton: { ...queueControlButtonColors },
  },
}

export const homeColorKeys = createColorKeys(topNavColors)
